import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkipPrevious10 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99992 11.3334L1.33325 8.00002L5.99992 4.66669V11.3334Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0127 5.888C14.1911 5.888 14.9072 6.77342 14.9072 8.30988C14.9072 9.85935 14.1911 10.7318 13.0127 10.7318C11.8345 10.7316 11.1182 9.8527 11.1182 8.30988C11.1182 6.76705 11.8345 5.88816 13.0127 5.888ZM10.0898 10.6663H9.10645V6.88409H9.08105L8 7.56085V6.69562L9.16504 5.95343H10.0898V10.6663ZM13.0127 6.68878C12.466 6.689 12.1211 7.23587 12.1211 8.30988C12.1146 9.3969 12.466 9.92392 13.0127 9.92413C13.5596 9.92413 13.9118 9.39711 13.9053 8.30988C13.9053 7.23566 13.5596 6.68878 13.0127 6.68878Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgSkipPrevious10);
export default ForwardRef;
